import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { FieldType, Formatters, Editors, AngularUtilService, OnEventArgs } from 'angular-slickgrid';
import { CustomAngularComponentEditor } from '../../../common/components/cue-table/custom-editors/custom-angular-component-editor';
import { AutoCompleteComponent } from '../../../common/components/auto-complete/auto-complete.component';
import { CustomAngularComponentFilter } from '../../../common/components/cue-table/custom-editors/custom-angular-component-filter';
import { CustomNumberOnlyEditor } from '../../../common/components/cue-table/custom-editors/number-only.editor';
import { GridDateFormatter } from 'src/app/common/components/cue-table/custom-formatters/custom-date-formatter';
import { DateTimePickerComponent } from 'src/app/common/components/date-time-picker/date-time-picker.component';


@Injectable()
export class RouteCreateService {
  selectedRouteFormValues: object = {};
  getrouteFilterConfig = {
    'showSideBar': false,
    'showReset': true
  };
  routeList = [];
  activeRouteIndex: number;
  isFromTransaction = false;

  constructor(private angularUtilService: AngularUtilService) { }


  getrouteTimeDetailsConfig = {
    'showSideBar': false,
    'showReset': true
  };
  selectedRouteNo: string;

  //form1
  getrouteCreateTemplate(scope: any) {
    return [{
      'id': 'strRouteId',
      'labelName': 'Route Code',
      'type': 'input',
      'inputType': '',
      'patchValue': '',
      'validations': [Validators.required],
      'isReadOnly': false,
      'isVisible': true,
      'position': 0,
      'class': 'col-md-4',
      'scope': scope,
      'isHelper': true,
      'helperConfig': {
        'title': 'Route Help',
        'modalComponent': scope.getModalComponent,
        'helperCallback': scope.updateFormValues
      },
      'onEnter': scope.updateFormValues
    }, {
      'id': 'strRouteDesc',
      'labelName': 'Route Description',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': false,
      'changeApi': '',
      'validations': [Validators.required],
      'position': 1,
      'class': 'col-md-4'
    }, {
      'id': 'strStatus',
      'labelName': 'Status',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': true,
      'changeApi': '',
      'validations': [],
      'position': 2,
      'class': 'col-md-4'
    }, {
      'id': 'strOrigin',
      'labelName': 'Origin',
      'type': 'search',
      'placeholder': 'Select Origin',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'datasource': [],
      'validations': [Validators.required],
      'position': 3,
      'class': 'col-md-4'
    }, {
      'id': 'strVia',
      'labelName': 'Via',
      'type': 'search',
      'placeholder': 'Select Route',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'datasource': [],
      'validations': [Validators.required],
      'position': 4,
      'class': 'col-md-4'
    }, {
      'id': 'strDestination',
      'labelName': 'Destination',
      'type': 'search',
      'placeholder': 'Select Destination',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'datasource': [],
      'validations': [Validators.required],
      'position': 5,
      'class': 'col-md-4'
    }];
  }

  //form2
  getrouteTimeDetailsTemplate() {
    return [{
      'id': 'iTotalDistance',
      'labelName': 'Total Distance',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': true,
      'changeApi': '',
      'validations': [],
      'position': 0,
      'class': 'col-md-4'
    }, {
      'id': 'strDistanceUom',
      'labelName': 'UOM',
      'type': 'search',
      'placeholder': 'Select UOM',
      'minlength': 1,
      'isVisible': true,
      'isReadOnly': false,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'datasource': [],
      'validations': [],
      'position': 1,
      'class': 'col-md-4'
    }, {
      'id': 'strTotalTime',
      'labelName': 'Total Time(HH:MM)',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': true,
      'changeApi': '',
      'validations': [],
      'position': 1,
      'class': 'col-md-4'
    }];
  }

  //grid
  getRouteTableColumnConfig(scope) {
    return [
      //   {
      //   id: 'id',
      //   name: 'Seq No',
      //   field: 'id',
      //   sortable: true,
      //   minWidth: 45,
      //   columnGroup: 'Route Transit Details',
      //   formatter: function (row) { return (row + 1); },
      // },
      {
        id: 'ROUTE_DTL_SEQ_NO',
        name: 'Sequence No',
        field: 'ROUTE_DTL_SEQ_NO',
        sortable: true,
        type: FieldType.integer,
        editor: { model: CustomNumberOnlyEditor },
        columnGroup: 'Route Transit Details',
        minWidth: 50
      }, {
        id: 'INTRANSIT_ORIGIN',
        name: 'Starting Location *',
        field: 'INTRANSIT_ORIGIN',
        comboId: 'strIntransitOrigin',
        filterable: true,
        sortable: true,
        columnGroup: 'Route Transit Details',
        minWidth: 200,
        queryFieldFilter: 'INTRANSIT_ORIGIN.id',
        queryFieldSorter: 'INTRANSIT_ORIGIN.value',
        formatter: Formatters.complexObject,
        params: {
          complexFieldLabel: 'INTRANSIT_ORIGIN.value',
        },
        editor: {
          model: CustomAngularComponentEditor,
          collection: [],
          params: {
            component: AutoCompleteComponent,
            configs: {
              'id': 'INTRANSIT_ORIGIN',
              'placeholder': 'Select Origin',
              'comboId': 'strIntransitOrigin',
              'displayField': 'value',
              'valueField': 'id',
              'enableVirtualScroll': true,
              'bufferSize': 25,
              'isGrid': true,
              'model': '',
              'datasource': []
            }
          }
        },
        filter: {
          model: new CustomAngularComponentFilter(),
          collection: [],
          params: {
            component: AutoCompleteComponent
          }
        },
        onCellChange: (e: Event, args: OnEventArgs) => {
        }
      }, {
        id: 'INTRANSIT_DEST',
        name: 'Transit Location *',
        field: 'INTRANSIT_DEST',
        comboId: 'strIntransitDestination',
        sortable: true,
        type: FieldType.string,
        filterable: true,
        minWidth: 200,
        columnGroup: 'Route Transit Details',
        queryFieldFilter: 'INTRANSIT_DEST.id',
        queryFieldSorter: 'INTRANSIT_DEST.value',
        formatter: Formatters.complexObject,
        params: {
          complexFieldLabel: 'INTRANSIT_DEST.value',
        },
        editor: {
          model: CustomAngularComponentEditor,
          collection: [],
          params: {
            component: AutoCompleteComponent,
            configs: {
              'id': 'INTRANSIT_DEST',
              'placeholder': 'Select Destination',
              'comboId': 'strIntransitDestination',
              'displayField': 'value',
              'valueField': 'id',
              'enableVirtualScroll': true,
              'bufferSize': 25,
              'isGrid': true,
              'model': '',
              'datasource': []
            }
          }
        },
        filter: {
          model: new CustomAngularComponentFilter(),
          collection: [],
          params: {
            component: AutoCompleteComponent
          }
        },
        onCellChange: (e: Event, args: OnEventArgs) => {
        }
      }, {
        id: 'ROUTE_LEG',
        name: 'Route Leg Category',
        field: 'ROUTE_LEG',
        comboId: 'strRouteLeg',
        sortable: true,
        type: FieldType.string,
        filterable: true,
        minWidth: 120,
        columnGroup: 'Route Transit Details',
        queryFieldFilter: 'ROUTE_LEG.id',
        queryFieldSorter: 'ROUTE_LEG.value',
        formatter: Formatters.complexObject,
        params: {
          complexFieldLabel: 'ROUTE_LEG.value',
        },
        editor: {
          model: CustomAngularComponentEditor,
          collection: [],
          params: {
            component: AutoCompleteComponent,
            configs: {
              'id': 'ROUTE_LEG',
              'placeholder': 'Select Route Leg',
              'comboId': 'strRouteLeg',
              'displayField': 'value',
              'valueField': 'id',
              'enableVirtualScroll': true,
              'bufferSize': 25,
              'isGrid': true,
              'model': '',
              'datasource': []
            }
          }
        },
        filter: {
          model: new CustomAngularComponentFilter(),
          collection: [],
          params: {
            component: AutoCompleteComponent
          }
        },
        onCellChange: (e: Event, args: OnEventArgs) => {
        }
      }, {
        id: 'CONSTRAINT_CODE',
        name: 'Constraint',
        field: 'CONSTRAINT_CODE',
        comboId: 'strConstraintCode',
        sortable: true,
        filterable: true,
        columnGroup: 'Route Transit Details',
        minWidth: 120,
        queryFieldFilter: 'CONSTRAINT_CODE.id',
        queryFieldSorter: 'CONSTRAINT_CODE.value',
        formatter: Formatters.complexObject,
        params: {
          complexFieldLabel: 'CONSTRAINT_CODE.value',
        },
        editor: {
          model: CustomAngularComponentEditor,
          collection: [],
          params: {
            component: AutoCompleteComponent,
            configs: {
              'id': 'CONSTRAINT_CODE',
              'placeholder': 'Select Code',
              'comboId': 'strConstraintCode',
              'displayField': 'value',
              'valueField': 'id',
              'enableVirtualScroll': true,
              'bufferSize': 25,
              'isGrid': true,
              'model': '',
              'datasource': []
            }
          }
        },
        filter: {
          model: new CustomAngularComponentFilter(),
          collection: [],
          params: {
            component: AutoCompleteComponent
          }
        },
        onCellChange: (e: Event, args: OnEventArgs) => {
        }
      }, {
        id: 'DISTANCE',
        name: 'Distance (km) *',
        field: 'DISTANCE',
        sortable: true,
        type: FieldType.integer,
        editor: { model: CustomNumberOnlyEditor },
        formatter: Formatters.decimal,
        columnGroup: 'Route Transit Details',
        minWidth: 100,
        cssClass: 'text-align-right'
      }, {
        id: 'TRANSIT_TIME',
        name: 'Transit Time (HH:MM) *',
        field: 'TRANSIT_TIME',
        sortable: true,
        dateFormat: 'HH:mm',
        formatter: GridDateFormatter,
        minWidth: 120,
        type: FieldType.string,
        editor: {
          model: CustomAngularComponentEditor,
          params: {
            component: DateTimePickerComponent,
            configs: {
              'id': 'TRANSIT_TIME',
              'type': 'datePicker',
              'maxDate': '',
              'minDate': '',
              'invalidDates': [],
              'disabledDays': [],
              'validations': [],
              'noOfMonths': 1,
              'isDisabled': false,
              'isGrid': true,
              'model': '',
              'dateFormat': 'HH:mm',
              'placeholder': 'HH:MM',
              'pickerType': 'timer'
            }
          }
        },
        cssClass: 'text-align-right'
      }, 
      // {
      //   id: 'PIVOT_POINT',
      //   name: 'Pivot Point*',
      //   field: 'PIVOT_POINT',
      //   comboId: 'strPivotPoint',
      //   sortable: true,
      //   type: FieldType.string,
      //   filterable: true,
      //   minWidth: 200,
      //   columnGroup: 'Route Transit Details',
      //   queryFieldFilter: 'PIVOT_POINT.id',
      //   queryFieldSorter: 'PIVOT_POINT.value',
      //   formatter: Formatters.complexObject,
      //   params: {
      //     complexFieldLabel: 'PIVOT_POINT.value',
      //   },
      //   
      //   editor: {
      //     model: CustomAngularComponentEditor,
      //     collection: [],
      //     params: {
      //       component: AutoCompleteComponent,
      //       configs: {
      //         'id': 'PIVOT_POINT',
      //         'placeholder': 'Select Pivot',
      //         'comboId': 'strPivotPoint',
      //         'displayField': 'value',
      //         'valueField': 'id',
      //         'enableVirtualScroll': true,
      //         'bufferSize': 25,
      //         'isGrid': true,
      //         'model': '',
      //         'datasource': []
      //       }
      //     }
      //   },
      //   filter: {
      //     model: new CustomAngularComponentFilter(),
      //     collection: [],
      //     params: {
      //       component: AutoCompleteComponent
      //     }
      //   },
      //   onCellChange: (e: Event, args: OnEventArgs) => {
      //   }
      // }
      {
        id: 'BOARDING_TIME',
        name: 'Boarding Time',
        field: 'BOARDING_TIME',
        sortable: true,
        dateFormat: 'HH:mm',
        formatter: GridDateFormatter,
        type: FieldType.string,
        editor: {
          model: CustomAngularComponentEditor,
          params: {
            component: DateTimePickerComponent,
            configs: {
              'id': 'BOARDING_TIME',
              'type': 'datePicker',
              'maxDate': '',
              'minDate': '',
              'invalidDates': [],
              'disabledDays': [],
              'validations': [],
              'noOfMonths': 1,
              'isDisabled': false,
              'isGrid': true,
              'model': '',
              'dateFormat': 'HH:mm',
              'placeholder': 'HH:MM',
              'pickerType': 'timer'
            }
          }
        },
        columnGroup: 'Route Transit Details',
        minWidth: 120,
        cssClass: 'text-align-right'
      }, {
        id: 'WAITING_TIME',
        name: 'Waiting Time',
        field: 'WAITING_TIME',
        sortable: true,
        dateFormat: 'HH:mm',
        formatter: GridDateFormatter,
        minWidth: 120,
        type: FieldType.string,
        editor: {
          model: CustomAngularComponentEditor,
          params: {
            component: DateTimePickerComponent,
            configs: {
              'id': 'WAITING_TIME',
              'type': 'datePicker',
              'maxDate': '',
              'minDate': '',
              'invalidDates': [],
              'disabledDays': [],
              'validations': [],
              'noOfMonths': 1,
              'isDisabled': false,
              'isGrid': true,
              'model': '',
              'dateFormat': 'HH:mm',
              'placeholder': 'HH:MM',
              'pickerType': 'timer'
            }
          }
        },
        columnGroup: 'Route Transit Details',
        cssClass: 'text-align-right'
      },
    ];
  }

  //config
  getrouteTableConfigs(scope) {
    return {
      gridId: 'routeCreateTable',
      idField: 'id',
      containerHeight: '98vh',
      canExportAsExcel: true, // TODO: Need to Configure
      selectionMode: 'multiple', // TODO: Need to configure
      exportFileName: '',
      dateFormat: 'DD/MM/YYYY',
      canAddRowManually: true,
      canDeleteRowManually: true,
      canCopyRows: true,
      canCopyMat: true,
      showColumnFilter: false,
      emptyObject: {},
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableCheckboxSelector: true,
      enableRowSelection: true,
      editable: true,
      showFilter: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: false
      },
      createPreHeaderPanel: false,
      showPreHeaderPanel: true,
      enablePagination: false,
      enableGrouping: false,
      autoEdit: true,
      alwaysShowVerticalScroll: false,
      forceFitColumns: false,
      asyncEditorLoading: false,
      autoCommitEdit: true,
      enableAsyncPostRender: true,
      asyncPostRenderDelay: 0,
      selectedRowKeyName: 'id',
      params: { angularUtilService: this.angularUtilService },
      onAddRow: scope.onAddRowinGrid,
      scope: scope
    };
  }
}
